<script>
  import Seo from "$lib/components/SEO.svelte";
  import { setContext } from "svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";

  export let data;
  const contributors = data.contributorsData;
  setContext("contributors", contributors);
</script>

<Seo data={data.pageEntry.fields} currentUrl={data.currentUrl} cookieBanner={data.cookieBanner} />

<PageBody body={data.pageEntry.fields.body} class="page-body last-page-element" />
